import Config from './services/Config/Config';
import Cookies from 'cookies-ts';
import {CSRFManager} from './services/CSRFProtection';
import ErrorHandler from './services/ErrorHandler/ErrorHandler';
import Dispatcher from './services/Events/Dispatcher';
import Database from './services/Database/Database';
import Localisation from './services/Localisation/Localisation';
import DotAccessor from './services/DotAccessor/DotAccessor';
import Http from './services/Http/Http';
import Store from './_redux/store';
import StoreEvents from './services/StoreEvents/StoreEvents';
import URLGenerator from './services/URLGenerator/URLGenerator';
import ClientRouter from './services/Router/ClientRouter';
import ApiRouter from './services/Router/ApiRouter';
import Forms from './services/Forms/Forms';
import YupSchemeBuilder from './services/YupSchemeBuilder/YupSchemeBuilder';
import Storage from './services/Storage/Storage';
import Auth from './services/Auth/Auth';
import Theme from './services/Theme/Theme';
import ControllersRepository from './services/ControllersRepository/ControllersRepository';
import {IContainedServices} from './@interfaces/services/Container/IContainedServices';
import ConfigMaker from './services/ConfigMaker/ConfigMaker';
import NamesResolver from './services/NameResolvers/NamesResolver';
import PriceFormatter from './services/Formatter/PriceFormatter';
import AsyncUploader from './services/Http/AsyncUploader';
import Client from './services/WebSocket/Client';
import Settings from './services/Settings/Settings';
import FilesViewer from './services/FileViewer/FilesViewer';
import SoundsPlayer from '@src/services/SoundsPlayer/SoundsPlayer';
import CommentRepository from '@src/services/CommentRepository/CommentRepository';
import JsonStorage from '@src/services/Storage/JsonStorage';

const nameResolver = new NamesResolver();

const services: IContainedServices = {
    'config': new Config(),
    'cookies': new Cookies(),
    'CSRFManager': new CSRFManager(),
    'errorHandler': new ErrorHandler(),
    'events': new Dispatcher(),
    'db': new Database(),
    'trans': new Localisation(),
    'dot-accessor': new DotAccessor(),
    'http': new Http(),
    'store': Store,
    'store-events': new StoreEvents(),
    'url': new URLGenerator(),
    'client-router': new ClientRouter(),
    'api-router': new ApiRouter(),
    'forms': new Forms(),
    'scheme-builder': new YupSchemeBuilder(),
    'storage': (
        // `Container.get` considers construction like `() => new Function()` as constructable and call that function immediately
        () => (prefix?: string) => new Storage(prefix)
    ) as any,
    'storage:json': (
        // `Container.get` considers construction like `() => new Function()` as constructable and call that function immediately
        () => <TValues extends Record<string, any>, >(prefix?: string) => new JsonStorage<TValues>(prefix)
    ) as any,
    'settings': new Settings(),
    'auth': new Auth(),
    'theme': new Theme(),
    'controllers': new ControllersRepository(),
    'config-maker': new ConfigMaker(),
    'names-resolver': nameResolver,
    'price-formatter': new PriceFormatter(),
    'queryKeys': nameResolver.queryKeys,
    'queryKeys:default': nameResolver.queryKeys,
    'async-uploader': new AsyncUploader(),
    'files-viewer': new FilesViewer(),
    'ws': new Client({}),
    'sounds-player': new SoundsPlayer(),
    'comments': new CommentRepository(),
};

export default services;
